var _path, _mask, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMp4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.75H26.0439L34.25 8.28711V36C34.25 37.7949 32.7948 39.2499 31 39.25H9C7.20507 39.25 5.75 37.7949 5.75 36V4C5.75 2.20508 7.20508 0.75 9 0.75Z",
    stroke: "#DEDEDE",
    strokeWidth: 1.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_13828_32223",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 1H33.5V9.5H26C25.4477 9.5 25 9.05229 25 8.5V1Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 1H33.5H25ZM33.5 11H26C24.6193 11 23.5 9.88071 23.5 8.5L26.5 8H33.5V11ZM26 11C24.6193 11 23.5 9.88071 23.5 8.5V1H26.5V8L26 11ZM33.5 1V9.5V1Z",
    fill: "#DEDEDE",
    mask: "url(#path-2-inside-1_13828_32223)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 20,
    width: 24,
    height: 12,
    rx: 2,
    fill: "#4956F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.03653 22.574H6.02553L7.52853 26.993H7.54653L8.96853 22.574H10.9575V29H9.63453V24.446H9.61653L8.04153 29H6.95253L5.37753 24.491H5.35953V29H4.03653V22.574ZM13.6146 25.598H14.7126C14.8746 25.598 15.0306 25.586 15.1806 25.562C15.3306 25.538 15.4626 25.493 15.5766 25.427C15.6906 25.355 15.7806 25.256 15.8466 25.13C15.9186 25.004 15.9546 24.839 15.9546 24.635C15.9546 24.431 15.9186 24.266 15.8466 24.14C15.7806 24.014 15.6906 23.918 15.5766 23.852C15.4626 23.78 15.3306 23.732 15.1806 23.708C15.0306 23.684 14.8746 23.672 14.7126 23.672H13.6146V25.598ZM12.2016 22.574H15.0996C15.5016 22.574 15.8436 22.634 16.1256 22.754C16.4076 22.868 16.6356 23.021 16.8096 23.213C16.9896 23.405 17.1186 23.624 17.1966 23.87C17.2806 24.116 17.3226 24.371 17.3226 24.635C17.3226 24.893 17.2806 25.148 17.1966 25.4C17.1186 25.646 16.9896 25.865 16.8096 26.057C16.6356 26.249 16.4076 26.405 16.1256 26.525C15.8436 26.639 15.5016 26.696 15.0996 26.696H13.6146V29H12.2016V22.574ZM20.3915 24.302H20.3645L18.7355 26.489H20.3915V24.302ZM20.3915 27.542H17.7275V26.372L20.4635 22.7H21.6065V26.489H22.4435V27.542H21.6065V29H20.3915V27.542Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp4);
export default __webpack_public_path__ + "static/media/mp4.7f2d9a6fa9fc1b509245c5651ad53898.svg";
export { ForwardRef as ReactComponent };